<template>
	<div>
		<modalconfirm ref="modalconfirmAddTransfer" @action="proccessTransfer"/>
		<div class="text-h5">Permintaan Transfer Stok</div>
		<v-card class="mt-3" outlined>
			<v-form ref="formTransfer" role="form" v-on:submit.prevent="addTransfer">
				<v-card-text class="pt-2">
					<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
						{{alert.message}}
					</v-alert>
					<v-row>
						<v-col cols="12" md="3">
							<v-autocomplete :items="listWarehouse" v-model="to_warehouse" item-text="warehouse_name" label="Warehouse" return-object no-data-text="Tidak ada data yang sesuai" @focus="() => responseError.to_warehouse_id=''" :rules="[inputrules.required]" :error-messages="responseError.to_warehouse_id" outlined dense hide-details="auto">
							</v-autocomplete>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-textarea v-model="to_note" label="Catatan" rows="3" height="120" @focus="() => responseError.note=''" :error-messages="responseError.note" hide-details="auto" outlined dense no-resize></v-textarea>
						</v-col>
						<v-col cols="12" >
							<v-alert v-if="responseError.product" color="red lighten-4 pink--text text-body-2">
								<v-icon class="mt-n1" color="pink">mdi-alert-circle-outline</v-icon>
								<span class="pl-2">{{responseError.product}}</span>
							</v-alert>
							<v-simple-table>
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="5%" class="text-left">Aksi</th>
											<th width="40%" class="text-left">Nama Produk</th>
											<th width="25%" class="text-left">Kode Produk</th>
											<th width="15%" class="text-left">Jumlah</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(product, index) in productsSelected" :key="product.product_id">
											<td>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="deletefromTO(index)">
															<v-icon dark>mdi-delete</v-icon>
														</v-btn>
													</template>
													<span>Hapus</span>
												</v-tooltip>
											</td>
											<td>
												<v-autocomplete :items="productsNotSelected" :filter="customFilter" return-object item-text="product_name" v-model="product.data" no-data-text="Tidak ada data yang sesuai" :rules="[productRules]" class="py-3 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-autocomplete>
											</td>
											<td>
												<div class="pt-2">{{ product.data.product_code }}</div>
											</td>
											<td>
												<v-currency-field v-model.lazy="product.data.quantity" :rules="[inputrules.required, inputrules.notnull]" outlined dense hide-details="auto" background-color="white" class="py-3 details-mb-0"></v-currency-field>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="px-4 pb-4">
					<v-btn light depressed color="primary" @click="addProduct">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Produk</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" depressed class="text-capitalize" type="submit">Proses</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			to_warehouse: '',
			productsSelected: [],
			productRules: value => !!value.product_id || 'Tidak boleh kosong',
			to_note: '',
		}
	},
	computed: {
		...mapState('to', ['listWarehouse', 'listProduct', 'response', 'responseError', 'alertMultiple']),

		productsNotSelected() {
			if (this.productsSelected.length > 0) {
				const productSelected = this.productsSelected.map((el) => el.data)
				return this.listProduct.map((el) => {
					if (productSelected.includes(el)) {
						el.disabled = true
					} else {
						el.disabled = false
					}
					return el
				})
			}
			return this.listProduct
		},
	},
	methods: {
		...mapActions('supplierList', ['getSupplier']),
		...mapActions('to', ['createTO', 'getOptionWarehouse','getOptionProduct']),
		...mapMutations('to', ['saveResponse']),
		...mapMutations(['setOverlay']),

		customFilter (item, queryText) {
			const textOne = item.product_code.toLowerCase()
			const textTwo = item.product_name.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1
		},
		addProduct() {
			this.responseError.product = ''
			this.productsSelected.push({
				data: {
					product_id: '',
					product_name: '',
					quantity: '0',
				},
			})
		},
		deletefromTO(index) {
			this.productsSelected.splice(index, 1)
		},
		addTransfer() {
			if (this.$refs.formTransfer.validate()) {
				this.$refs.modalconfirmAddTransfer.setMessage('Apakah Anda yakin akan memproses transaksi ini?')
				this.$refs.modalconfirmAddTransfer.showConfirm()
			}
		},
		async proccessTransfer() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmAddTransfer.hideConfirm()
			let product = await this.productsSelected.map( (el) => {
				return {
					product_name: el.data.product_name,
					product_id: el.data.product_id,
					quantity: el.data.quantity,
					price: el.data.price,
				}
			})
			let params = await {
				from_warehouse_id: this.to_warehouse.warehouse_id,
				product: product,
				note: this.to_note,
			}
			await this.createTO(params).then(() => {
				if (this.response.code == 200.) {
					this.resetForm()
				}
			})
			await this.setOverlay(false)
		},
		resetForm() {
			this.saveResponse({})
			this.$refs.formTransfer.resetValidation()
			this.productsSelected = []
			this.to_warehouse = ''
			this.getOptionWarehouse({limit:100})
			this.getOptionProduct({limit:100})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Permintaan Transfer Stok`)
		this.getOptionWarehouse({limit:100})
		this.getOptionProduct({limit:100})
	},
	watch: {
	}
}
</script>